//
//  SDKAssetScaleType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var AssetScaleType;
(function (AssetScaleType) {
    AssetScaleType["aspectFill"] = "AspectFill";
    AssetScaleType["aspectFit"] = "AspectFit";
})(AssetScaleType || (AssetScaleType = {}));
